module.exports = __webpack_public_path__ + "static/439f38ae3093cb01879a05474b6f66ac.svg";